<template>
  <div>
    <div class="d-flex">
      <div class="form-check mr-2">
        <input class="form-check-input" type="radio" name="type" id="grouped" value="grouped" v-model="type" />
        <label class="form-check-label" for="grouped"> Grouped </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" name="type" id="stacked" value="stacked" v-model="type" />
        <label class="form-check-label" for="stacked"> Stacked </label>
      </div>
    </div>
    <highcharts :options="chartOptions" :ref="barchart_id"></highcharts>
  </div>
</template>

<script>
import Highcharts from "highcharts/highcharts.js";
import { Chart } from "highcharts-vue";
import moment from "moment";

export default {
  name: "bar_chart_group_stacked",
  props: {
    series: Array,
    topik: Array,
    height: {
      type: String,
      default: function () {
        return "400";
      },
    },
    barchart_id: {
      type: String,
      default: function () {
        return "barchart-element";
      },
    },
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      data: this.dataset,
      chartOptions: {},
      type: "stacked",
    };
  },
  methods: {
    loadChart: function () {
      let self = this;
      let categories = [];
      for (let i = 0; i < this.topik.length; i++) {
        categories[i] = this.topik[i].nama;
      }
      let data_positif = [];
      let data_netral = [];
      let data_negatif = [];
      let data = this.series;
      for (let i = 0; i < this.series[0].values.length; i++) {
        data_positif[i] = this.series[0].values[i].y;
      }
      for (let i = 0; i < this.series[1].values.length; i++) {
        data_netral[i] = this.series[1].values[i].y;
      }
      for (let i = 0; i < this.series[2].values.length; i++) {
        data_negatif[i] = this.series[2].values[i].y;
      }
      let series = [];
      series = [
        {
          color: "#28a745",
          name: "Positif",
          data: data_positif,
        },
        {
          color: "#17a2b8",
          name: "Netral",
          data: data_netral,
        },
        {
          color: "#dc3545",
          name: "Negatif",
          data: data_negatif,
        },
      ];
      this.chartOptions = {
        chart: {
          type: "column",
          backgroundColor: "transparent",
          height: self.height ? self.height : "",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },
        xAxis: {
          categories: categories,
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "Verdana, sans-serif",
            },
          },
        },
        yAxis: {
          min: 0,
          title: "",
        },
        plotOptions: {
          column: {
            stacking: self.type == "stacked" ? "normal" : "",
          },
          series: {
            label: {
              connectorAllowed: false,
            },
            point: {
              events: {
                click: function () {
                  // console.log(data)
                  let source = data.source
                  let query = data.query
                  let start = "";
                  let end = "";
                  let params = {};
                  let tgl = this.category.split(" ");
                  let tgl_str = tgl[2] + "-" + tgl[1] + "-" + tgl[0];
                  tgl = moment(tgl_str, "YYYY-MMM-DD");
                  if (tgl.isValid()) {
                    start = tgl.format("YYYY-MM-DD 00:00:00");
                    end = tgl.format("YYYY-MM-DD 23:59:59");
                  } else {
                    start = moment(self.$route.query.from).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    end = moment(self.$route.query.to).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                  }

                  params = {
                    from: start,
                    to: end,
                  };

                  if ("topic_selected" in self.$route.query) {
                    params.topic_selected = self.$route.query.topic_selected;
                  }
                  if ("cakupan" in self.$route.query) {
                    params.cakupan = self.$route.query.cakupan;
                  }

                  if (source) {
                    params.sources = btoa(source);
                  }

                  if (query) {
                    params.q = query;
                  }

                  self.$router.push({ path: "/posts", query: params });
                },
              },
            },
          },
        },
        legend: {
          enabled: true,
        },
        tooltip: {
          // pointFormat: "Jumlah Mention: <b>{point.y}</b>",
          shared: true,
          formatter: function () {
            let s = '<b>' + this.x + '</b>';
            this.points.forEach(function (point) {
              s += '<br/><span style="color:' + point.color + '">' + point.series.name + '</span>: ' +
                Highcharts.numberFormat(point.y, 0, ',', ',');
            });
            return s;
          }
        },
        series: series,
      };
    },
  },
  mounted: function () {
    if (this.topik != null && this.series != null) {
      this.loadChart();
    }
  },
  watch: {
    type() {
      this.loadChart();
    },
  },
};
</script>